import { useSearchParams } from 'react-router-dom';

import {
  CREATE_RESUME_PAGE,
  PROFILE_VISIBILITY,
  PROFILE_VISIBILITY_V2,
} from 'src/components/Router';
import { useCard } from 'src/components/Router/useCard';
import { usePage } from 'src/components/Router/usePage';
import { EDIT, type MODE, MODES, READ } from 'src/consts';
import type { Card } from 'src/types';

// Uses `card` param to avoid rendering all cards in 'EDIT' mode at once
export const useMode = (card?: Card): MODE | undefined => {
  const currentCard = useCard();
  const currentPage = usePage();
  const [searchParams] = useSearchParams();
  const mode = searchParams.get('mode')?.toUpperCase();
  // TODO: Remove special case when profile-visibility V1 removed
  const isProfileVisibilityV2Situation =
    card === PROFILE_VISIBILITY_V2 && currentCard === PROFILE_VISIBILITY;

  if (card !== currentCard && !isProfileVisibilityV2Situation) {
    return undefined;
  }

  if (MODES.includes(mode as MODE)) {
    return mode as MODE;
  }

  // NOTE: If 'CreateResume' page, the default to 'READ', tidier looking URLs
  return currentPage === CREATE_RESUME_PAGE ? READ : EDIT;
};
